export const environment = {
  production: false,
  environmentTitle: 'DEV',
  googleMapsApiKey: 'AIzaSyCgi3mJLzBSF6igfCYC2-Y3DgaMEILBKAM',
  azureClientId: '71335f80-b3b2-4cb9-9d15-948eafd8ebf8',
  azureApiScope: 'https://dukeenergy.onmicrosoft.com/71335f80-b3b2-4cb9-9d15-948eafd8ebf8/mattracker.read.write.api',
  azureTenantId: '2ede383a-7e1f-4357-a846-85886b2c0c4d',
  apiBaseUrl: 'https://mattracker-api-dev.duke-energy.app',
  reports: {
    damagedMats: 'https://app.powerbi.com/rdlEmbed?reportId=eea48547-8e82-47f2-b4db-7bf0d1246f08&autoAuth=true&ctid=2ede383a-7e1f-4357-a846-85886b2c0c4d&experience=power-bi',
    cancelledRequests: 'https://app.powerbi.com/rdlEmbed?reportId=487354e4-f4d5-44d1-8148-bf2bd9074ab4&autoAuth=true&ctid=2ede383a-7e1f-4357-a846-85886b2c0c4d&experience=power-bi',
    rentalMats: 'https://app.powerbi.com/rdlEmbed?reportId=53e336ce-e4eb-4f43-a9c0-f9baec58bc7e&autoAuth=true&ctid=2ede383a-7e1f-4357-a846-85886b2c0c4d&experience=power-bi'
  }
};
